import React, { useEffect, useState } from 'react'
import TabView from '../../components/tabview'
import AdvancedPayslip from './AdvancedPayslip'
import BasicPayslip from './BasicPayslip'
import DashboardLayout from '../../components/layouts/dashboard'

const PayrollPage = () => {
  useEffect(() => {
    window.scroll(0, 0)
  }, [])
  const [activeTab, setActiveTab] = useState(1)

  const payslipTabs = [
    {
      title: 'Advanced Payslip',
      Content: AdvancedPayslip,
    },
    {
      title: 'Basic Payslip',
      Content: BasicPayslip,
    },
  ]

  return (
    <DashboardLayout title='My Payslips'>
      <div className='font-bold text-lg'>Payslip History</div>
      <div className='flex flex-col bg-white rounded-[16px] p-3'>
        <TabView
          Tabs={payslipTabs}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
      </div>
    </DashboardLayout>
  )
}

export default PayrollPage
